const styles = {
  form: { position: "unset" },
  locationSection: {
    marginTop: `35px`,
    paddingRight: "unset",
    paddingLeft: "unset"
  }
};

export default styles;
